import { render, staticRenderFns } from "./ProductsField.vue?vue&type=template&id=49ef1b4d&scoped=true"
import script from "./ProductsField.vue?vue&type=script&lang=ts"
export * from "./ProductsField.vue?vue&type=script&lang=ts"
import style0 from "./ProductsField.vue?vue&type=style&index=0&id=49ef1b4d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49ef1b4d",
  null
  
)

export default component.exports